<template>
    <v-menu v-model="isShowMenu" offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on }">
            <v-text-field                 
                v-model="selectedCategoryItemName"
                v-bind="$attrs"
                readonly 
                clearable 
                outlined 
                persistent-hint 
                append-icon="mdi-menu-down"
                v-on="on" />
        </template>
        <v-list v-if="canEdit">
            <template v-for="category in items">
                <v-list-group no-action :key="category.categoryID">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>{{category.name}}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item v-for="item in category.items" :key="item.id" @click="onSelectedItem(category, item)">
                        <v-list-item-content>{{item.name}}</v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </template>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            /**
             * v-model: {categoryID, id}
             */
            value: null,
            /**
             * 全選択項目
             */
            items: {
                type: Array,
                default: []
            },
            /** 編集可否 */
            canEdit: {
                type: Boolean,
                default: true
            },
        },
        computed: {
            selectedValue: {
                get: function () {
                    return this.$props.value
                },
                set: function (v) {
                    this.$emit("input", v)
                }
            }
        },
        data: function () {
            return {
                isShowMenu: false,
                selectedCategoryItemName: ""
            }
        },
        mounted: function () {
            if (this.value != null && this.value.categoryID != null && this.value.id != null) {
                this.selectedCategoryItemName = this.getItemName(this.value.categoryID, this.value.id)
            }
        },
        methods: {
            onClickClearPlace: function () {
                console.log("onClickClearPlace")
                this.selectedCategoryItemName = ""
                this.selectedValue = null
            },
            onSelectedItem: function (category, item) {
                console.log("onSelectedItem", item)
                this.selectedCategoryItemName = item.name
                this.isShowMenu = false
                this.selectedValue = {
                    categoryID: category.categoryID,
                    id: item.id
                }
            },
            /**
             * 指定されたカテゴリーで、指定されたIDの名称を返す
             */
            getItemName: function (categoryID, id) {
                const i = this.items.findIndex((v)=>v.categoryID == categoryID)
                if (i < 0) return "unknown"
                const j = this.items[i].items.findIndex((v)=>v.id == id)
                if (j < 0) return "unknown"
                return this.items[i].items[j].name
            }
        }
    }
</script>
